<template>
  <tbody class="result-row-clickable">
    <tr @click="onShowClick">
      <td v-if="displayItems.reminderId" class="c-table__cell--middle reminder-id-cell">
        <p class="reminder-id-cell__text">
          {{ message.reminder_id }}
        </p>
      </td>
      <td v-if="displayItems.message" class="c-table__cell--middle">
        <div class="mini-preview-container">
          <template v-if="isReminder && firstSchedule">
            <div class="mini-preview-card">
              <div class="mini-preview-card__body">
                <div class="mini-preview-card__content">
                  <div v-if="message.badge_image_url" class="mini-preview-card__badge-row">
                    <img :src="message.badge_image_url" class="mini-preview-card__badge" />
                    <div class="mini-preview-card__url">{{ message.click_url }}</div>
                  </div>
                  <div v-else class="mini-preview-card__url">{{ message.click_url }}</div>
                  <div class="mini-preview-card__title">{{ replacePlaceholders(firstSchedule.message_title) }}</div>
                  <div class="mini-preview-card__text">{{ replacePlaceholders(firstSchedule.message_text) }}</div>
                </div>
                <div v-if="resolvedIconUrl" class="mini-preview-card__icon">
                  <img :src="resolvedIconUrl" />
                </div>
              </div>
              <div v-if="message.large_image_url" class="mini-preview-card__image">
                <img :src="message.large_image_url" />
              </div>
            </div>
          </template>
          <template v-else>
            <div class="mini-preview-card">
              <div class="mini-preview-card__body">
                <div class="mini-preview-card__content">
                  <div v-if="message.badge_image_url" class="mini-preview-card__badge-row">
                    <img :src="message.badge_image_url" class="mini-preview-card__badge" />
                    <div class="mini-preview-card__url">{{ message.click_url }}</div>
                  </div>
                  <div v-else class="mini-preview-card__url">{{ message.click_url }}</div>
                  <div class="mini-preview-card__title">{{ replacePlaceholders(message.message_title) }}</div>
                  <div class="mini-preview-card__text">{{ replacePlaceholders(message.message_text) }}</div>
                </div>
                <div v-if="resolvedIconUrl" class="mini-preview-card__icon">
                  <img :src="resolvedIconUrl" />
                </div>
              </div>
              <div v-if="message.large_image_url" class="mini-preview-card__image">
                <img :src="message.large_image_url" />
              </div>
            </div>
          </template>
        </div>
      </td>
      <td v-if="displayItems.deliverCount" class="c-table__cell--middle c-table__cell--center">
        <span class="deliver-count-badge">{{ scheduleCount }}通</span>
      </td>
      <td v-if="displayItems.condition" class="c-table__cell--middle">
        <reminder-condition-summary :condition="message.condition" mode="minimap" />
      </td>
      <td v-if="displayItems.workingTime" class="c-table__cell--middle c-table__cell--center">
        <template v-if="hasWorkingTime">
          <div class="working-time-range">
            <span>{{ workingStartFormatted }}</span>
            <span class="working-time-range__separator">〜</span>
            <span>{{ workingEndFormatted }}</span>
          </div>
        </template>
      </td>
      <td v-if="displayItems.deliverStatus" class="c-table__cell--middle c-table__cell--center">
        <span :class="message.deliver_flag === 1 ? 'deliver-badge deliver-badge--active' : 'deliver-badge deliver-badge--stopped'">{{ displayDeliverFlag }}</span>
      </td>
      <td v-if="displayItems.displayCount" class="c-table__cell--middle c-table__cell--center result-num">
        {{ summaryMessage.display_count }}
      </td>
      <td v-if="displayItems.clickCount" class="c-table__cell--middle c-table__cell--center result-num">
        {{ summaryMessage.click_count }}
      </td>
      <td v-if="displayItems.ctr" class="c-table__cell--middle c-table__cell--center result-num">
        {{ ctr }}
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: {
    summaryMessage: Object,
    defaultIconUrl: String,
    displayItems: Object,
  },
  emits: ["show-click"],
  computed: {
    message: function () {
      return this.summaryMessage && this.summaryMessage.reminder_message
        ? this.summaryMessage.reminder_message
        : {};
    },
    isReminder: function () {
      return this.message.schedules && this.message.schedules.length > 0;
    },
    firstSchedule: function () {
      if (!this.isReminder) return null;
      return this.message.schedules.find(s => s.schedule_index === 0) || this.message.schedules[0];
    },
    resolvedIconUrl: function () {
      return this.message.icon_url || this.defaultIconUrl;
    },
    scheduleCount: function () {
      if (this.isReminder) return this.message.schedules.length;
      return 1;
    },
    hasWorkingTime: function () {
      return this.message.working_start_time != null && this.message.working_end_time != null;
    },
    workingStartFormatted: function () {
      var v = this.message.working_start_time;
      return String(Math.floor(v / 100)).padStart(2, '0') + ':' + String(v % 100).padStart(2, '0');
    },
    workingEndFormatted: function () {
      var v = this.message.working_end_time;
      return String(Math.floor(v / 100)).padStart(2, '0') + ':' + String(v % 100).padStart(2, '0');
    },
    displayDeliverFlag: function () {
      return this.message.deliver_flag === 1 ? '配信中' : '停止中';
    },
    ctr: function () {
      if (this.summaryMessage.display_count > 0 && this.summaryMessage.click_count > 0) {
        var ctr = this.summaryMessage.click_count * 100 / this.summaryMessage.display_count;
        return ctr.toFixed(2) + '%';
      }
      return '0.00%';
    },
  },
  methods: {
    onShowClick: function () {
      this.$emit('show-click', this.summaryMessage);
    },
    replacePlaceholders: function (text) {
      if (!text) return text;
      var placeholders = this.message.placeholders || [];
      placeholders.forEach(function (ph) {
        if (ph.placeholder_key) {
          var replacement = ph.default_value || '{{' + ph.placeholder_key + '}}';
          text = text.split('{{' + ph.placeholder_key + '}}').join(replacement);
          text = text.split('{' + ph.placeholder_key + '}').join(replacement);
        }
      });
      return text;
    },
  },
};
</script>

<style scoped>
.mini-preview-container {
    display: flex;
    gap: 10px;
    padding: 6px 0;
    overflow-x: auto;
    /* table-layout: auto 時にセル幅でクリップさせるため flex の min-content を抑制する */
    min-width: 0;
}

.mini-preview-card {
    position: relative;
    background: #fff;
    border: 1.5px solid #ccc;
    border-radius: 8px;
    min-width: 220px;
    max-width: 280px;
    flex-shrink: 0;
    overflow: hidden;
}

.mini-preview-card__body {
    display: flex;
    padding: 8px 10px;
    gap: 8px;
}

.mini-preview-card__content {
    flex: 1;
    min-width: 0;
    overflow: hidden;
}

.mini-preview-card__badge-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 3px;
}

.mini-preview-card__badge {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

.mini-preview-card__url {
    font-size: 11px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 3px;
}

.mini-preview-card__badge-row .mini-preview-card__url {
    margin-bottom: 0;
}

.mini-preview-card__title {
    font-size: 13px;
    font-weight: bold;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 2px;
}

.mini-preview-card__text {
    font-size: 11px;
    color: #666;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.4;
}

.mini-preview-card__icon {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 4px;
    overflow: hidden;
    background: #eee;
}

.mini-preview-card__icon img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.mini-preview-card__image {
    width: 100%;
    overflow: hidden;
}

.mini-preview-card__image img {
    width: 100%;
    display: block;
}

.list-condition-minimap {
    font-size: 11px;
    line-height: 1.5;
    padding: 4px 0;
}

.list-condition-minimap__row {
    display: block;
    padding-left: 1.2em;
    text-indent: -1.2em;
    color: #333;
    word-break: break-all;
}

.list-condition-minimap__row::before {
    content: '- ';
}

.list-condition-minimap__row + .list-condition-minimap__row {
    margin-top: 2px;
}

.working-time-range {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.4;
    color: #333;
}

.working-time-range__separator {
    color: #888;
}

.deliver-count-badge {
    display: inline-block;
    font-weight: normal;
    color: #333;
    white-space: nowrap;
}

.deliver-badge {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 10px;
    border-radius: 10px;
}

.deliver-badge--active {
    background: #d8f0f6;
    color: #209bb9;
}

.deliver-badge--stopped {
    background: #e8e8e8;
    color: #888;
}

.result-num {
    font-size: 13px;
    white-space: nowrap;
}

.result-row-clickable tr {
    cursor: pointer;
}

.result-row-clickable tr:hover td {
    background-color: #f5f5f5;
}

/*
 * リマインダーIDセル: 任意の長さのIDが入っても列幅 (th 側の m-w120) を超えず、
 * 折り返してテーブルレイアウトを保つ。スペースを含まない長いIDでも改行できるよう
 * word-break: break-all を併用する。
 */
.reminder-id-cell {
    word-break: break-all;
    overflow-wrap: anywhere;
}
.reminder-id-cell__text {
    margin: 0;
    line-height: 1.5;
    word-break: break-all;
    overflow-wrap: anywhere;
}
</style>

<style>
.p-message-result__data .c-table tbody tr td {
    font-size: 14px;
}
.u-text-ellipsis {
  width: 100%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
}

.u-text-ellipsis:not(:hover) {
  text-overflow: ellipsis;
}
</style>
